import React from "react";

import { Tooltip, Box, Stack } from "@chakra-ui/react";

import useTranslations from "../../../../hooks/useTranslations";

import AnswerFrom from "./AnswerForm";

import { AnswerReviewProps } from "./types/AnswerReviewProps";
import TextareaLikeBox from "./TextareaLikeBox";

const AnswerTextReview: React.FC<AnswerReviewProps> = React.memo(
  ({ answer, path }) => {
    const t = useTranslations();

    if (answer.isEmpty) return null;

    return (
      <Stack spacing="4">
        <AnswerFrom {...{ answer, path }} />
        <Tooltip
          textAlign="center"
          placement="bottom"
          label={t("reports.shared.immutableAnswer") as string}
        >
          <Box maxWidth="2xl" w="full">
            <TextareaLikeBox
              id={`${path}.answer.${answer.id}.value`}
              answer={answer}
              value={answer?.value}
            />
          </Box>
        </Tooltip>
      </Stack>
    );
  }
);

export default AnswerTextReview;
